import HttpRequestService from "./HttpRequestService";

const CommonService = {};

//API for get all data
CommonService.getAllCountries = function () {
  return HttpRequestService.get("country");
};
//Api for get data by id
CommonService.getAllStateByCountryId = function (id) {
  return HttpRequestService.get("state/" + id);
};

CommonService.sendContactUs = function(payload) {
  return HttpRequestService.post("/ContactUs", payload)
}

CommonService.sendAppointment = function(payload) {
  return HttpRequestService.post("/appointment", payload)
}

export default CommonService;
